import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-media gfu-media--middle _mb-1"
}
const _hoisted_2 = { class: "gfu-media__body gfu-comment-field__author" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-hd gfu-hd--h4 _mr-a"
}
const _hoisted_4 = {
  key: 1,
  class: "gfu-bt gfu-bt--b2 _tc--light _mr-a"
}
const _hoisted_5 = ["lang", "placeholder"]
const _hoisted_6 = { class: "gfu-comment-field__actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_field = _resolveComponent("field")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-comment-field', {'gfu-comment-field': !$options.hasNickname}]),
    "data-qa": "project-comments-field:AddNew"
  }, [
    (_ctx.projectContext.isInTestMode)
      ? (_openBlock(), _createBlock(_component_base_notificator, {
          key: 0,
          "can-close": false,
          class: "_mb-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.Comments.CommentsInTestModeInfoParagraph), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(['gfu-comment-field__wrap', {'is-focused': $data.isFocused }]),
      onClick: _cache[6] || (_cache[6] = (...args) => ($options.focus && $options.focus(...args)))
    }, [
      ($options.hasNickname)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!$options.isEdit)
              ? (_openBlock(), _createBlock(_component_base_image, {
                  key: 0,
                  src: _ctx.userContext.avatarUrl,
                  alt: $options.user.nickname,
                  width: "24",
                  height: "24",
                  class: "gfu-comment-field__avatar gfu-avatar gfu-avatar--clean _mr-1",
                  loading: "lazy"
                }, null, 8 /* PROPS */, ["src", "alt"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_2, [
              (!$options.isEdit)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_3, _toDisplayString($options.user.nickname), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($options.isEdit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.Resources.Comments.CommentFieldEditingHeader), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_tooltip, null, {
                content: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.Resources.Comments.CommentFieldCapabilitiesHeader), 1 /* TEXT */),
                    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(_ctx.Resources.Comments.CommentFieldCapabilitiesOption1), 1 /* TEXT */)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_base_icon, { name: "circle-info" })
                ]),
                _: 1 /* STABLE */
              })
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_field, {
        modelValue: $data.text,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.text) = $event)),
        name: "text",
        "show-label": false,
        "display-name": "comment",
        class: "_mt-0",
        "data-qa": "comment-input-field"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref: "commentInput",
            lang: _ctx.selectedLanguage,
            contenteditable: "true",
            class: "gfu-comment-field__editor",
            placeholder: _ctx.Resources.Comments.CommentFieldPlaceholder,
            onFocus: _cache[0] || (_cache[0] = (...args) => ($options.onFocus && $options.onFocus(...args))),
            onBlur: _cache[1] || (_cache[1] = (...args) => ($options.onBlur && $options.onBlur(...args))),
            onPaste: _cache[2] || (_cache[2] = (...args) => ($options.onPaste && $options.onPaste(...args))),
            onKeypress: _cache[3] || (_cache[3] = _withKeys((...args) => ($options.onEnterKeypress && $options.onEnterKeypress(...args)), ["enter"])),
            onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers((...args) => ($options.onCtrlEnterKeydown && $options.onCtrlEnterKeydown(...args)), ["ctrl","prevent"]), ["enter"])),
            "data-qa": "comment-input"
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"])
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_6, [
      ($options.isCancelable)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "#",
            class: "gfu-link gfu-link--accent _ttl",
            onClick: _cache[7] || (_cache[7] = _withModifiers((...args) => ($options.onCancel && $options.onCancel(...args)), ["prevent"])),
            "data-qa": "project-comment-button:Cancel"
          }, _toDisplayString(_ctx.Resources.Common.ModalCancelButton), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_base_button, {
        theme: "accent",
        class: "gfu-btn--micro _ml-3",
        enabled: $options.isSubmitable,
        onClick: $options.onSubmit,
        "data-qa": "project-comment-button:Send"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($options.submitLabel), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["enabled", "onClick"])
    ])
  ], 2 /* CLASS */))
}